import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {"position":"top-center","duration":3000,"iconPack":"mdi","action":{"text":"","icon":"mdi-window-close","onClick":(_, toastObject) => {
        toastObject.goAway(0);
      }}})

const globals = undefined
if(globals) {
  globals.forEach(global => {
    Vue.toasted.register(global.name, global.message, global.options)
  })
}

export default function (ctx, inject) {
  inject('toast', Vue.toasted)
}
